import { useSelector } from "react-redux";
import clsx from "clsx";
import { TRANSLATION_STATE } from "../../constants/AudioTranslationConstants";
import useLanguageChange from "../../hooks/useLanguageChange";
import "./audioTranslation.scss";

const AudioTranslationStatus = () => {
    const localisedValues = useLanguageChange();
    const { translationEnabled, translationState, currentTranslatedText, currentOriginalText, translatedTextVisible, errorMessage } = useSelector(
        (state) => state.audioTranslation
    );

    if (!translationEnabled) return null;

    return (
        <div className={clsx("audio-translation-status", translatedTextVisible && "show-text")}>
            {translationState === TRANSLATION_STATE.STARTING && (
                <div className='translation-status-badge starting'>{localisedValues?.starting_translation || "Starting translation..."}</div>
            )}
            {translationState === TRANSLATION_STATE.ACTIVE && translatedTextVisible && (
                <div className='translation-text-overlay'>
                    {currentOriginalText && <div className='original-text'>{currentOriginalText}</div>}
                    <div className='translated-text'>{currentTranslatedText}</div>
                </div>
            )}
            {translationState === TRANSLATION_STATE.ERROR && (
                <div className='translation-status-badge error'>{errorMessage || localisedValues?.translation_error || "Translation error"}</div>
            )}
        </div>
    );
};

export default AudioTranslationStatus;
